module.exports = __webpack_public_path__ + "static/media/show_details.3b30f16e.svg";